import FileDetector from './fileDetector';

export default FileDetector;



// WEBPACK FOOTER //
// ./src/components/fileDetector/index.jsx